/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { TooltipData } from "@visx/xychart";
import { KeyValue } from "~/models";
import { Maybe } from "~/tools/types";

export type DataItem = {
  value: string;
  date: string;
  benefit?: string;
  coveredHours?: string;
  recommendedHours?: string;
};

export type TimePoint = {
  value: string;
  date: string;
  additionalFields?: Maybe<KeyValue[]>;
};

export type KpiTarget = {
  name: string;
  value: string;
  startDate: string;
  endDate: string;
};

export enum TARGET_TYPE {
  positive,
  negative,
}

type AdditionalData = {
  data: TimePoint[];
  title: string;
};

export type KpiChartProps = {
  targetType?: TARGET_TYPE;
  width: number;
  height: number;
  name: string;
  data: TimePoint[];
  additionalData?: AdditionalData;
  targets: KpiTarget[];
  loading?: boolean;
  startDate: string;
  endDate: string;
  simplified?: boolean;
};

export type KpiTimePoint = {
  date: string;
  value?: number;
  additionalValue?: number;
  targetName?: string;
  targetValue?: number;
  isEstimated?: boolean;
  isEstimationPadding?: boolean;
  additionalFields?: KeyValue[];
};

export type GenerateDataSeriesProps = {
  from: string;
  to: string;
  primaryData: TimePoint[];
  additionalData?: TimePoint[];
  targets: KpiTarget[];
  simplified?: boolean;
  currency: string;
};

export type GetValueFromTimePointProps = {
  date: string;
  timePoints: TimePoint[];
  additionalTimePoints: TimePoint[];
  currency: string;
};

export type KeyValueWithColor = KeyValue & {
  color?: string;
};

export type TimePointTooltipProps = {
  tooltipData?: TooltipData<KpiTimePoint>;
  targetType: TARGET_TYPE;
  kpiName: string;
  additionalTitle?: string;
};

export type GetKpiValueColorProps = {
  kpiValue?: number;
  targetValue?: number;
  targetType: TARGET_TYPE;
  defaultColor?: string;
};
